// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_PROCESS_DC_REQUEST = 'FETCH_ACCESSORIES_PROCESS_DC_REQUEST';
export const FETCH_ACCESSORIES_PROCESS_DC_SUCCESS = 'FETCH_ACCESSORIES_PROCESS_DC_SUCCESS';
export const FETCH_ACCESSORIES_PROCESS_DC_FAILURE = 'FETCH_ACCESSORIES_PROCESS_DC_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_ACCESSORIES_PROCESS_DC_REQUEST = 'CREATE_ACCESSORIES_PROCESS_DC_REQUEST';
export const CREATE_ACCESSORIES_PROCESS_DC_SUCCESS = 'CREATE_ACCESSORIES_PROCESS_DC_SUCCESS';
export const CREATE_ACCESSORIES_PROCESS_DC_FAILURE = 'CREATE_ACCESSORIES_PROCESS_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_ACCESSORIES_PROCESS_DC = 'CREATE_USER_FORM_ACCESSORIES_PROCESS_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_ACCESSORIES_PROCESS_DC_REQUEST = 'UPDATE_ACCESSORIES_PROCESS_DC_REQUEST';
export const UPDATE_ACCESSORIES_PROCESS_DC_SUCCESS = 'UPDATE_ACCESSORIES_PROCESS_DC_SUCCESS';
export const UPDATE_ACCESSORIES_PROCESS_DC_FAILURE = 'UPDATE_ACCESSORIES_PROCESS_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_ACCESSORIES_PROCESS_DC_REQUEST = 'FETCH_SINGLE_ACCESSORIES_PROCESS_DC_REQUEST';
export const FETCH_SINGLE_ACCESSORIES_PROCESS_DC_SUCCESS = 'FETCH_SINGLE_ACCESSORIES_PROCESS_DC_SUCCESS';
export const FETCH_SINGLE_ACCESSORIES_PROCESS_DC_FAILURE = 'FETCH_SINGLE_ACCESSORIES_PROCESS_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_ACCESSORIES_PROCESS_DC_REQUEST = 'DELETE_ACCESSORIES_PROCESS_DC_REQUEST';
export const DELETE_ACCESSORIES_PROCESS_DC_SUCCESS = 'DELETE_ACCESSORIES_PROCESS_DC_SUCCESS';
export const DELETE_ACCESSORIES_PROCESS_DC_FAILURE = 'DELETE_ACCESSORIES_PROCESS_DC_FAILURE';

// USERFORM RESET

export const ACCESSORIES_PROCESS_DC_USERFORM_RESET = 'ACCESSORIES_PROCESS_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_ACCESSORIES_PROCESS_DC_DETAILS = 'NAVIGATE_ACCESSORIES_PROCESS_DC_DETAILS';
// navigate to company component
export const NAVIGATE_ACCESSORIES_PROCESS_DC = 'NAVIGATE_ACCESSORIES_PROCESS_DC';

export const RESET_ACCESSORIES_PROCESS_DC_INVOICE = 'RESET_ACCESSORIES_PROCESS_DC_INVOICE';

export const SET_GRID_PAGE_INDEX_ACCESSORIES_PROCESS_DC = 'SET_GRID_PAGE_INDEX_ACCESSORIES_PROCESS_DC';

export const ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';

export const ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'ACCESSORIES_PROCESS_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

//FETCH INVOICE DATA
export const FETCH_ACCESSORIES_PROCESS_DC_INVOICE_REQUEST = 'FETCH_ACCESSORIES_PROCESS_DC_INVOICE_REQUEST';
export const FETCH_ACCESSORIES_PROCESS_DC_INVOICE_SUCCESS = 'FETCH_ACCESSORIES_PROCESS_DC_INVOICE_SUCCESS';
export const FETCH_ACCESSORIES_PROCESS_DC_INVOICE_FAILURE = 'FETCH_ACCESSORIES_PROCESS_DC_INVOICE_FAILURE';

export const DELETE_BTN_UPDATE_API_REQUEST_DC = 'DELETE_BTN_UPDATE_API_REQUEST_DC';
export const DELETE_BTN_UPDATE_API_SUCCESS_DC = 'DELETE_BTN_UPDATE_API_SUCCESS_DC';
export const DELETE_BTN_UPDATE_API_FAILURE_DC = 'DELETE_BTN_UPDATE_API_FAILURE_DC';

export const FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST = 'FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST';
export const FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS = 'FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS';
export const FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE = 'FETCH_ACCESSORIES_PROCESS_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE';

// export const CLOSE_BTN_POST_REQUEST_ACCESSORIES = 'CLOSE_BTN_POST_REQUEST_ACCESSORIES'
// export const CLOSE_BTN_POST_SUCCESS_ACCESSORIES = 'CLOSE_BTN_POST_SUCCESS_ACCESSORIES'
// export const CLOSE_BTN_POST_FAILURE_ACCESSORIES = 'CLOSE_BTN_POST_FAILURE_ACCESSORIES'

// export const CHECK_ALL_UPDATE_REQUEST_ACCESSORIES = 'CHECK_ALL_UPDATE_REQUEST_ACCESSORIES';
// export const CHECK_ALL_UPDATE_SUCCESS_ACCESSORIES = 'CHECK_ALL_UPDATE_SUCCESS_ACCESSORIES';
// export const CHECK_ALL_UPDATE_FAILURE_ACCESSORIES = 'CHECK_ALL_UPDATE_FAILURE_ACCESSORIES';
